import { Component } from '@angular/core';

import { ScrollAnimateDirective } from '../../../directives/scroll-animate.directive';

@Component({
  selector: 'app-flexible-section',
  imports: [ScrollAnimateDirective],
  templateUrl: './flexible-section.html',
  styleUrl: './flexible-section.css',
})
export class FlexibleSection {}
